import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import advancedSearch from '../views/advanced_search.vue' 
import excavate from '../views/excavate.vue' 
import medicalRecords from '../views/medicalRecords.vue' 
import subject from '../views/subject.vue'  

import searchDetails from "../views/search_details/search_details.vue"
import searchMedical from '../views/seach_page/search_medical.vue' 
import { Message } from 'element-ui';
import axios from 'axios';
// import { getCookie } from "@/utils/auth.js"
Vue.prototype.$http = axios
Vue.prototype.$message = Message;
Vue.use(VueRouter)

const routes = [
	{
		path:'/',
		redirect:'/advancedSearch'
	},
	{
		path: '/advancedSearch',
		name: 'advancedSearch',
		component: advancedSearch,
		meta: { title: '高级检索', requiredLogin: false }
	},
	{
		path: '/medicalRecords',
		name: 'medicalRecords',
		component: medicalRecords,
		meta: { title: '医案录入', requiredLogin: false }
	},
    {
		path: '/subject',
		name: 'subject',
		component: subject,
		meta: { title: '专题服务', requiredLogin: false }
	},
	{
		path: '/searchDetails',
		name: 'searchDetails',
		component: searchDetails,
		meta: { title: '医案检索详情', requiredLogin: false }
	}, 
	{
		path: '/searchMedical',
		name: 'searchMedical',
		component: searchMedical,
		meta: { title: '检索详情页', requiredLogin: false }
	},

]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach( (to, from, next) => {
	if(to.meta.title){//判断是否有标题
		document.title = ''+to.meta.title
	}
  if (to.matched.some(record => record.meta.requiredLogin)) {
    // 判断用户是否处于登录状态
    // console.log('store.getters.isLogin=',store.getters.isLogin)
    if (!getCookie.getItem('token')) {
      // next('/sign-in')
      Message({
        message: '此模块需要登录，请先登录再操作！',
        type: 'warning'
      });
      // console.log('to.fullPath=',to.fullPath)
      // router.push({ path: '/sign-in', query: {redirect:to.fullPath}});
      router.push({ path: '/login'});
    } else {
      if (to.meta.title) {
        document.title = to.meta.title
      }
      next();
      if (getCookie.getItem('token')) {
        store.commit("userToken", sessionStorage.getItem('token'))
      }
      if (to.path === '/login') return next();
      const token = sessionStorage.getItem('token')
      // if (!token) return next('/index');
      // next();
    }
  } else {
    next()
  }
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
